import { Skeleton } from "@devhop/ui";
import { CheckCircle2Icon, InfoIcon, ShoppingBagIcon } from "lucide-react";
import { SummaryCard } from "@/shared/ui/SummaryCard";
import { useShopsStatsQuery } from "../api/queries";

export function ShopsStatsCards() {
  const { data, isLoading } = useShopsStatsQuery();

  if (isLoading) {
    return (
      <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-24 rounded-xl" />
        ))}
      </div>
    );
  }

  const stats = data ?? {
    total: 0,
    active: 0,
    verified: 0,
    pendingApproval: 0,
  };

  return (
    <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <SummaryCard
        title="ຮ້ານທັງໝົດ"
        items={[{ label: "", value: stats.total.toLocaleString() }]}
        gridCols={2}
        valueSpan={1}
        icon={ShoppingBagIcon}
        color="default"
        titleClassName="font-medium text-xs uppercase tracking-wider"
        contentClassName="font-bold text-2xl tracking-tight"
      />
      <SummaryCard
        title="ຮ້ານທີ່ໃຊ້ງານ"
        icon={ShoppingBagIcon}
        items={[{ label: "", value: stats.active.toLocaleString() }]}
        gridCols={2}
        valueSpan={1}
        color="success"
        titleClassName="font-medium text-xs uppercase tracking-wider"
        contentClassName="font-bold text-2xl tracking-tight"
      />
      <SummaryCard
        title="ຄູ່ຄ້າຢືນຢັນ"
        icon={CheckCircle2Icon}
        items={[{ label: "", value: stats.verified.toLocaleString() }]}
        gridCols={2}
        valueSpan={1}
        color="primary"
        titleClassName="font-medium text-xs uppercase tracking-wider"
        contentClassName="font-bold text-2xl tracking-tight"
      />
      <SummaryCard
        title="ລໍຖ້າອະນຸມັດ"
        icon={InfoIcon}
        items={[{ label: "", value: stats.pendingApproval.toLocaleString() }]}
        gridCols={2}
        valueSpan={1}
        color="orange"
        titleClassName="font-medium text-xs uppercase tracking-wider"
        contentClassName="font-bold text-2xl tracking-tight"
      />
    </div>
  );
}
